export class UserActionIdentifiers {
  public static LoginUserActionID = '60225dc1-45dc-4b63-b98b-3f1760b0f40c';
  public static readonly LoginInterfaceElementID = '00000000-0000-0000-0000-000000000000';
  public static LoginSessionID = '';
}
